const routes = [
    {
        path: "/",
        redirect: "/dashboard/lead",
    },
    {
        path: "/admin",
        component: () => import("../components/Admin/dashboard/index.vue"),
    },
    {
        path: "/modules",
        component: () => import("../components/Module/design.vue"),
    },
    {
        path: "/admin/dashboard",
        component: () =>
            import("../components/Admin/dashboard/admindashboard.vue"),
    },
    {
        path: "/admin/followup/calllog",
        component: () => import("../components/Admin/FollowUp/calllog.vue"),
        name: "followup.calllog",
    },
    {
        path: "/admin/calllog/summary",
        component: () => import("../components/Admin/Summary/summary.vue"),
        name: "followUp.summary",
    },

    {
        path: "/admin/calllog/cossummary",
        component: () => import("../components/Admin/Summary/cossummary.vue"),
        name: "followUp.cossummary",
    },

    {
        path: "/admin/followup/log",
        component: () => import("../components/Admin/FollowUp/followUpLog.vue"),
        name: "followup.log",
    },
    {
        path: "/admin/followup/notif_list/:user?",
        component: () =>
            import("../components/Admin/FollowUp/followUpNotifications.vue"),
        name: "followup.notifications",
    },

    {
        path: "/admin/leadmaster/:id",
        component: () =>
            import("../components/Admin/Leadmaster/leadmaster.vue"),
        name: "leadMasters",
    },

    {
        path: "/admin/teamrights",
        component: () =>
            import("../components/Admin/teamrights/teamrights.vue"),
    },
    {
        path: "/admin/managepermission",
        redirect: "/admin/setup/adminmaster/3",
        name: "admin.permissions",
    },
    {
        path: "/admin/form",
        component: () => import("../components/Admin/Form/form.vue"),
        name: "form.setup",
    },

    {
        path: "/admin/formfields/:id",
        component: () => import("../components/Admin/FormField/formFields.vue"),
        name: "viewFormFields",
    },
    {
        path: "/admin/leaddetail/:id/:tab?",
        component: () =>
            import("../components/Admin/LeadDetail/leadDetail.vue"),
        name: "LeadDetails",
    },

    {
        path: "/admin/whatsapptemplate/:lead_id",
        component: () =>
            import("../components/Admin/LeadDetail/whatsappTemplate.vue"),
        name: "TemplateModal",
        props: true,
    },
    {
        path: "/admin/customer",
        component: () => import("../components/Admin/Customer/customer.vue"),
        name: "customers",
    },
    {
        path: "/admin/customer/:id",
        component: () => import("../components/Admin/Customer/customer.vue"),
        name: "customer",
    },

    {
        path: "/dashboard/lead",
        component: () =>
            import("../components/Admin/dashboard/leadDashboard.vue"),
        name: "dashbord.lead",
    },

    {
        path: "/admin/mydeals",
        component: () => import("../components/Admin/Deal/myDeal.vue"),
        name: "deals",
    },
    {
        path: "/admin/mydeals/:id",
        component: () => import("../components/Admin/Deal/myDeal.vue"),
        name: "deal",
    },
    {
        path: "/admin/product/group",
        component: () => import("../components/Admin/Product/productGroup.vue"),
        name: "product.group",
    },
    {
        path: "/admin/product/units",
        component: () => import("../components/Admin/Product/productUnits.vue"),
        name: "product.unit",
    },
    {
        path: "/admin/product",
        component: () => import("../components/Admin/Product/product.vue"),
        name: "products",
    },
    {
        path: "/admin/proposal",
        component: () => import("../components/Admin/Proposal/proposal.vue"),
        name: "proposal",
    },
    {
        path: "/admin/invoice",
        component: () => import("../components/Admin/Invoice/invoice.vue"),
        name: "invoices",
    },
    {
        path: "/admin/invoice/:id?",
        component: () => import("../components/Admin/Invoice/invoice.vue"),
        name: "invoice",
    },

    {
        path: "/admin/activities",
        component: () =>
            import("../components/Admin/Activities/activities.vue"),
        name: "activities",
    },

    {
        path: "/admin/facebookSetup",
        component: () => import("../components/Admin/social/setupFacebook.vue"),
    },
    {
        path: "/admin/userprofile",
        component: () => import("../components/Admin/User/userProfile.vue"),
        name: "user.profile",
    },
    {
        path: "/admin/search",
        component: () => import("../components/Admin/Search/leadsearch.vue"),
        name: "search",
    },
    {
        path: "/admin/database",
        component: () => import("../components/Admin/Database/DataBase.vue"),
        name: "database",
    },
    {
        path: "/admin/setup/adminmaster/:tab?",
        component: () => import("../components/Admin/Masters/adminMaster.vue"),
        name: "setup.adminmaster",
    },
    {
        path: "/admin/setup/leadmaster",
        component: () => import("../components/Admin/Masters/leadMaster.vue"),
        name: "setup.leadmaster",
    },
    {
        path: "/admin/setup/templatemaster",
        component: () =>
            import("../components/Admin/Masters/templateMaster.vue"),
        name: "setup.templatemaster",
    },
    {
        path: "/admin/field/collection/:id",
        component: () =>
            import("../components/Admin/FieldCollection/fieldCollection.vue"),
        name: "field_collection",
    },
];
export default routes;
